import type { FaireProductEntity } from "../../entity_types/product";

export const p_y9wrcjv5r7: FaireProductEntity = {
  token: "p_y9wrcjv5r7",
  type: "product",
  name: "Melamine Full Alphabet - Stripes - 3 x Each Letter - Pinkish Colors - Medium - 250 ml",
  brandToken: "b_c8yganb0qb",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/061cf20ffa0f22fe82dee0d25a47eaacf4546b1acad23f20df65469562f5296f.png",
  galleryImageUrls: [],
  priceDollars: 225,
  description:
    "Melamine Full Alphabet - Stripes - 3 x Each Letter - Bluish Colors - Medium - 8.45 oz by RICE by RICE. Add a splash of color and fun to your daily routine.\n\nPersonalize your table with alphabet styles—fun for kids and grown‑ups alike. Made of high‑quality melamine: durable, lightweight and easy to clean—perfect for everyday use and outdoor dining.\n\n * Material: Melamine \n * Capacity: 8.45 oz (8.45 oz) \n * Dimensions: Diameter × Height: 3.54 in × 3.54 in \n * Care: Top-rack dishwasher safe. Not for microwave. ",
  tags: [],
  msrpDollars: 450,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.604Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
